import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex items-center justify-between gap-2 pb-2 print:hidden",
  "data-cy": "bulk-action-bar"
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "flex gap-2" }

import type { PropType } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlStatusBadge from '@/components/LlStatusBadge.vue';

// Purely presentational - the parent (MattersTable.vue) owns the bulk
// operations composable, confirmation dialogs, and process/error state.
// It has to: this bar unmounts via v-if the instant a bulk action clears
// the selection, so any state it owned would disappear before the parent
// could render per-row results from it.

export default /*@__PURE__*/_defineComponent({
  __name: 'BulkActionBar',
  props: {
  selectedIds: { type: Array as PropType<string[]>, required: true },
  archived: { type: Boolean, default: false },
  matterTerm: { type: String, default: 'Matter' },
  bulkOperationLoading: { type: Boolean, default: false },
  // Per-action permission gates - the parent already checks permissions.matters.create
  // as the floor for showing this bar at all; these narrow individual buttons further.
  // canApplyRateGroup requires both Rates and Assign - applying a rate group edits both
  // the matter's rates and its MatterShare users, so it counts as "editing rates and
  // users" even though the singular (non-bulk) rate-group path doesn't enforce Assign
  // today. Default to true so any other future consumer that doesn't pass them isn't
  // silently broken.
  canChangeResponsible: { type: Boolean, default: true },
  canApplyRateGroup: { type: Boolean, default: true },
  canArchive: { type: Boolean, default: true },
},
  emits: [
  'clear',
  'change-responsible',
  'archive',
  'apply-rate-group',
  'enable-ledes',
  'disable-ledes',
],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LlStatusBadge, { "data-cy": "selection-count-badge" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.selectedIds.length) + " " + _toDisplayString(__props.matterTerm) + _toDisplayString(__props.selectedIds.length === 1 ? '' : 's') + " selected ", 1)
        ]),
        _: 1
      }),
      _createVNode(LlSecondaryButton, {
        variant: "text",
        "data-cy": "clear-selection-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear')))
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode(" Clear ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.canChangeResponsible)
        ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            variant: "outlined",
            color: "primary",
            "prepend-icon": "mdi-account-switch",
            loading: __props.bulkOperationLoading,
            disabled: __props.bulkOperationLoading,
            "data-cy": "change-responsible-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-responsible')))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Change Responsible ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true),
      (__props.canApplyRateGroup)
        ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 1,
            variant: "outlined",
            color: "primary",
            "prepend-icon": "mdi-cash-multiple",
            loading: __props.bulkOperationLoading,
            disabled: __props.bulkOperationLoading,
            "data-cy": "apply-rate-group-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('apply-rate-group')))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" Apply Rate Group ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true),
      (__props.canArchive)
        ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 2,
            style: {"border":"1px solid #9e9e9e"},
            "prepend-icon": __props.archived ? 'mdi-archive-arrow-up' : 'mdi-archive-arrow-down',
            loading: __props.bulkOperationLoading,
            disabled: __props.bulkOperationLoading,
            "data-cy": "archive-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('archive')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.archived ? 'Unarchive' : 'Archive'), 1)
            ]),
            _: 1
          }, 8, ["prepend-icon", "loading", "disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_menu, null, {
        activator: _withCtx(({ props: menuProps }) => [
          _createVNode(LlSecondaryButton, _mergeProps(menuProps, {
            variant: "outlined",
            "append-icon": "mdi-menu-down",
            disabled: __props.bulkOperationLoading,
            "data-cy": "more-actions-button"
          }), {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode(" More actions ", -1)
            ]))]),
            _: 1
          }, 16, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, { density: "compact" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-file-check-outline",
                "data-cy": "enable-ledes-item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('enable-ledes')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Enable LEDES", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-file-remove-outline",
                "data-cy": "disable-ledes-item",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('disable-ledes')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("Disable LEDES", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})